module.exports = "<symbol id=\"thebestco-uikit-svg-DownThin16\" viewBox=\"0 0 18 18\"><path d=\"M1 5L9 13L17 5\"/></symbol>";